import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SquareObjectDataset } from 'app/model/dataset/square.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'SquareSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(SquareObjectDataset) }
})
export class SquareCopySource extends TabularCopySource {
}
